export default {
  Btn_Common: {
    TuoZhuai: '拖拽',
    QueDing: '确定',
    QuXiao: '取消',
    XinZeng_ZhuanJieMa: '新增转介码',
    XiuGai_ZhuanJieMa: '修改转介码',
    XinZeng_ShouQuan: '新增授权',
    XiuGai: '修改',
    Chufang_Yulan: '处方预览',
    DengRu: '登录',
    ChaXun: '查询',
    ChongZhi: '重置',
    XinZeng: '新增',
    FenPei_JueSe: '分配角色',
    PaiBan_HaoYuan: '排班号源',
    ChongZhi_MiMa: '重置密码',
    QueRen: '确认',
    GuanBi: '关闭',
    FuZhi: '复制',
    FuZhi_QuanBu: '复制全部',
    ZhanTie: '粘贴',
    BaoCun: '保存',
    YiSheng_Duan: '医生端',
    XiuGai_ZhangHao_MiMa: '修改账号密码',
    TuiChu_DengLu: '退出登录',
    ShuaXin: '刷新',
    GuanBi_QiTa: '关闭其它',
    GuanBi_SuoYou: '关闭所有',
    XinZeng_JueSe: '新增角色',
    FenPei_QuanXian: '分配权限',
    ChaKan_QuanXian: '查看权限',
    ShanChu: '删除',
    XiuGai_JueSe: '修改角色',
    XinZeng_YouHuiQuan: '新增优惠券',
    FaFang: '发放',
    PeiSong: '配送',
    TianJia_DiZhi: '添加地址',
    XiaZai: '下载',
    XinZeng_DingDan: '新增订单',
    ShenPi: '审批',
    QianShou: '签收',
    WanJie: '完结',
    QianShou_JiLu: '签收记录',
    ShenHe: '审核',
    XuanZe_YaoPin: '选择药品',
    QingKong_DingDan: '清空订单',
    ZanCun: '暂存',
    TiJiao: '提交',
    Shang_Yi_Bu: '上一步',
    QingChu: '清除',
    ShangChuan: '上传',
    YuLan: '预览',
    YuLan_Hou_TiJiao: '预览后提交',
    XiuGai_MiMa: '修改密码',
    XuanZe_XueWei: '选择穴位',
    XinZeng_YaoPin: '新增药品',
    TongBu: '同步',
    ShouFei_ZongJie: '收费总结',
    TongBu_GengXin: '同步更新',
    XinZeng_ShangPin: '新增商品',
    XinZeng_BingRen: '新增病人',
    XinZeng_TaoPiao: '新增套票',
    TianRu: '填入',
    QuanBu_XuanZhong: '全部选中',
    QuXiao_XuanZhong: '取消选中',
    ShengCheng_HaoYuan: '生成号源',
    XinZeng_ZhenSuo: '新增诊所',
    XiuGai_ZhenSuo: '修改诊所',
    PeiZhi: '配置',
    SouXun: '查询',
    PiCi: '批次',
    XiuGai_YaoPin: '修改药品',
    YaoPin: '药品',
    WanCheng: '完成',
    TianJia_ZuiXinJiLu: '添加最新记录',
    BianJi_ZuiJinJiLu: '编辑最近记录',
    FenPei: '分配',
    JiaRu_ZhengZhen: '加入诊症',
    ZhengZhen: '诊症',
    QingKong_SuoYou_PaiBan: '删除已保存规则',
    XinZeng_LuYou: '新增路由',
    XiuXi: '休息',
    TianJia: '添加',
    TianJia_ShiDuan: '添加时段',
    TianJia_FenZu: '添加分组',
    FaFang_QuanBu: '发放全部',
    YanQi: '延期',
    She_YouXiaoQi: '设有效期',
    YiXuan: '已选',
    QingKong: '清空',
    PaiBan_ShunXv: '排班顺序',
    LiShi_PaiBan: '历史排班',
    FenChai: '分拆',
    Yu_ShangDuan_HeBing: '与上段合并',
    XuanZe: '选择',
    XinZeng_ZuZhi: '新增组织',
    XiuGai_ZuZhi: '修改组织',
    ZhuanJie: '转介',
    ZhangHao_MiMa: '账号密码',
    ShengMing_BiaoZheng: '生命表征',
    JiaRu_ShiYanShi: '加入实验室纪录',
    ShouYe: '首页',
    ShangYiYe: '上一页',
    XiaYiYe: '下一页',
    QiTa: '其他',
    ZanWu_QuTianJia: '暂无，去添加',
    HeBing_HuanZhe_XinXi: '合并患者信息',
    QueRen_HeBing: '确认合并',
    Xia_Yi_Bu: '下一步',
    TiaoGuo: '跳过',
    FenPei_ZhenSuo: '分配诊所',
  },
}
